import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import {
  AppModal,
  AppNoInfo,
} from '@/layout/AppComponents';
import styled from 'styled-components';
import ReactDOMServer from 'react-dom/server';
import * as currentPageAction from '../../../../../store/actions/currentPageAction';
import AuxSidebar from '../../../../Sidebar/AuxSidebar';
import Translator from '../../../../components/helpers/Translator';
import InternalObligationForm from './InternalObligationForm';

export default function InternalObligationSidebarBlock({
  internalObligationTemplates,
  onReload,
}) {
  const dispatch = useDispatch();
  const { moduleBridgeHex } = useParams();
  const auxSidebar = useSelector(
    (state) => state.currentPage?.auxSidebar?.opened
  );
  const permissions = useSelector(
    (s) => s.module?.[moduleBridgeHex]?.permissions
  );
  const [openOnce, setOpenOnce] = useState(false);
  const [showModal, setShowModal] = useState(null);

  const handleAuxSidebar = () => {
    if (!openOnce) setOpenOnce(true);
    if (auxSidebar !== 'internalObligation') {
      dispatch(
        currentPageAction.change('auxSidebar', { opened: 'internalObligation' })
      );
    } else dispatch(currentPageAction.change('auxSidebar', { opened: null }));
  };

  if (!permissions?.gcl?.module?.plant?.manageInternalObligations) return null;

  if (!internalObligationTemplates) {
    return <AppNoInfo />;
  }

  return (
    <>
      <button
        className={`btn btn-xs btn-outline-light${
          internalObligationTemplates?.length === 0 ||
          internalObligationTemplates === undefined
            ? ' disabled'
            : ''
        }`}
        onClick={() =>
          internalObligationTemplates.length === 1
            ? setShowModal(internalObligationTemplates?.[0]?.id)
            : handleAuxSidebar()
        }
      >
        <Translator
          file="module-legalCompliance"
          name="new-internal-obligation"
        />
      </button>
      <AuxSidebar
        title={ReactDOMServer.renderToString(
          <Translator file="module-legalCompliance" name="select-type" />
        )}
        isOpen={auxSidebar && auxSidebar === 'internalObligation'}
        width="350px"
        position="left"
        onClose={handleAuxSidebar}
      >
        {openOnce && (
          <List>
            {internalObligationTemplates?.map((t) => (
              <li
                key={t.id}
                onClick={() => {
                  dispatch(
                    currentPageAction.change('auxSidebar', { opened: null })
                  );
                  setShowModal(t.id);
                }}
              >
                <span className="sidebar-element">
                  <b>{t.name}</b>
                </span>
              </li>
            ))}
          </List>
        )}
      </AuxSidebar>
      <AppModal
        show={showModal !== null}
        title={ReactDOMServer.renderToString(
          <Translator
            file="module-legalCompliance"
            name="new-internal-obligation"
          />
        )}
        onClose={() => setShowModal(null)}
        size="xl"
      >
        <InternalObligationForm
          internalObligationTemplateId={showModal}
          onReload={() => {
            onReload();
            setShowModal(null);
          }}
        />
      </AppModal>
    </>
  );
}

const List = styled.div`
  list-style: none;

  li {
    cursor: pointer;
    padding: 7px 10px;
  }
`;
